import { render, staticRenderFns } from "./ColoriFrontali.vue?vue&type=template&id=42ecad97"
import script from "./ColoriFrontali.vue?vue&type=script&lang=ts"
export * from "./ColoriFrontali.vue?vue&type=script&lang=ts"
import style0 from "./ColoriFrontali.vue?vue&type=style&index=0&id=42ecad97&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports